<script>
  import { useNavigate } from "svelte-navigator";
  import { onMount } from "svelte";
  import { Moon } from "svelte-loading-spinners";
  import { loadingStore, headerDisplayStore } from "../stores/General";
  import { create, update, getById } from "../api";
  import classNames from "../utils/classNames";
  import CampaignForm from "../components/campaign/CampaignForm.svelte";
  import FlightList from "../components/campaign/FlightList.svelte";
  export let id = "";
  let name = "";
  let campaign_id = "";
  let description = "";
  let start_at = "";
  let end_at = "";
  let budget = 0;
  let target_price = 0;
  let advertiser = "";
  let agency = "";
  let endpoint = "";
  let execution = "";
  let type = "";
  let targeting = {};

  const isUpdate = !!id;
  const navigate = useNavigate();

  const module_name = "campaign";
  // Campaign data object
  let campaign = null;

  const onCancel = () => {
    navigate("/campaign");
  };

  function onBudgetChange(event) {
    budget = event.detail.target.value;

    if (!isNaN(parseFloat(budget)) && !isNaN(parseFloat(target_price))) {
      impressions = Math.floor((budget / target_price) * 1000);
    }
  }

  function onTargetPriceChange(event) {
    target_price = event.detail.target.value;

    if (!isNaN(parseFloat(budget)) && !isNaN(parseFloat(target_price))) {
      impressions = Math.floor((budget / target_price) * 1000);
    }
  }

  function onStartDateChange(value) {
    if (value.detail) {
      const start = new Date(value.detail);

      if (end_at && start > end_at) {
        reset_end_at = true;

        setTimeout(() => {
          reset_end_at = false;
        }, 1000);
      }
      start_at = start;
    }
  }

  function onEndDateChange(value) {
    if (value.detail) {
      const end = new Date(value.detail);

      if (end && end < start_at) {
        reset_start_at = true;

        setTimeout(() => {
          reset_start_at = false;
        }, 1000);
      }
      end_at = end;
    }
  }

  // TODO: remove; handle in html for better reactivity
  const getStatusClass = (status) => {
    switch (status) {
      case "ended":
        return "bg-custom-light-green text-custom-green";
      case "live":
        return "bg-custom-light-red text-custom-red";
      default:
        return "bg-gray-100 text-black";
    }
  };

  function onSubmit(e) {
    if (e?.detail?.valid) {
      const save = id ? update : create;
      const data = {
        ...e.detail.data,
        campaign_id: id,
      };

      const newData = {
        ...data,
        // TODO: supposed to be an array but db model accepts a string
        // i.e. can only aaccept on advertiser for now
        advertiser: data.advertiser && data.advertiser.length ? data.advertiser[0].value : null,
        agency: data.agency ? data.agency.value : null,
        execution: data.execution ? data.execution.value : null,
      };

      loadingStore.on(module_name, { disableGlobalIndicator: true });
      save(module_name, newData)
        .then((response) => {
          if (response?.status === "ok") {
            headerDisplayStore.ShowNotification({
              title: "Success",
              subtitle: "Campaign saved successfully",
            });
            navigate("/campaign");
          } else {
            headerDisplayStore.ShowError({
              title: "Error",
              subtitle: response?.error,
            });
          }
          loadingStore.off(module_name)
        })
        .catch((error) => {
          headerDisplayStore.ShowError({
            title: "Server error",
            subtitle: error?.message,
          });
        });
    } else {
      headerDisplayStore.ShowError({
        title: "Cannot create campaign",
        subtitle: "Form is invalid",
      });
    }
  }

  async function getCampaign() {
    if (id) {
      try {
        loadingStore.on(module_name);
        const response = await getById(module_name, id);
        campaign = response.campaign[0];
        name = campaign?.name;
        campaign_id = campaign?.campaign_id;
        description = campaign?.description;
        start_at = campaign?.start_at;
        end_at = campaign?.end_at;
        budget = campaign?.budget;
        target_price = campaign?.target_price;
        advertiser = campaign?.advertiser ? [campaign?.advertiser] : [];
        agency = campaign?.agency;
        endpoint = campaign?.endpoint;
        execution = campaign?.execution;
        type = campaign?.type;
        targeting = campaign?.targeting;

        if (response.campaign_publishers) {
          campaign.publishers = [];
          response.campaign_publishers.forEach((cp) => {
            campaign.publishers.push({
              publisher_id: cp.publisher_id,
              target_price: cp.target_price,
              publisher_name: response.publishers.find(
                (p) => p.publisher_id === cp.publisher_id
              )?.name,
            });
          });
        }
      } catch (error) {
        headerDisplayStore.ShowError({
          title: "Server error",
          subtitle: error?.message,
        });
        navigate("/campaign");
      } finally {
        loadingStore.off(module_name);
      }
    }
  }

  onMount(() => {
    void getCampaign();
    headerDisplayStore.SetTitle(isUpdate ? "Edit Campaign" : "New Campaign");
    headerDisplayStore.SetBreadCrumbs([
      {
        key: "campaign",
        label: "Campaign",
      },
      {
        key: "new",
        label: "New",
      },
    ]);
  });
</script>

{#if (isUpdate && campaign) || !isUpdate}
  <div class="max-w-full mx-auto py-8 sm:px-6 md:px-10">
    <div class="bg-white p-8 w-full rounded-md">
      {#if !id || (id && campaign)}
        {#if campaign?.status}
          <div class="float-root">
            <p
              class={classNames(
                "float-right w-20 text-sm font-bold text-center rounded-3xl capitalize py-2",
                getStatusClass(campaign.status)
              )}
            >
              {campaign.status}
            </p>
          </div>
        {/if}
        <CampaignForm
          on:submitForm={onSubmit}
          on:cancel={onCancel}
          {name}
          {campaign_id}
          {description}
          {start_at}
          {end_at}
          {budget}
          {target_price}
          {advertiser}
          {agency}
          {endpoint}
          {execution}
          {targeting}
          {isUpdate}
        />
      {/if}
    </div>

    {#if !id || (id && campaign)}
      <FlightList {campaign_id} {targeting} />
    {/if}
  </div>
{/if}
